import { makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import { TextBoxComponent } from '../common/text-box/text-box.component';
import { PageHeaderMeganavContentItemComponent } from '../page/header/meganav/content/item/page-header-meganav-content-item.component';
import { CmsAccordionComponent } from './accordion/cms-accordion.component';
import { CmsAcoustics101Component } from './acoustics-101/cms-acoustics-101.component';
import { CmsAnalysisCalculatorComponent } from './analysis-calculator/cms-analysis-calculator.component';
import { CmsBlogComponentImageAndCopyComponent } from './blog/blog-image-and-copy/cms-blog-component-image-and-copy.component';
import { CmsBlogComponentImagesComponent } from './blog/blog-images/cms-blog-component-images.component';
import { CmsBlogComponentMoreStoriesComponent } from './blog/component/more-stories/cms-blog-component-more-stories.component';
import { CmsButtonComponent } from './button/cms-button.component';
import { CmsCaseStudiesComponent } from './case-studies/cms-case-studies.component';
import { CmsCategoryRoutingComponent } from './category-routing/cms-category-routing.component';
import { CmsCustomFormComponent } from './customform/cms-customform.component';
import { CmsDiscoveryQuizComponent } from './discovery-quiz/cms-discovery-quiz.component';
import { CmsEditorialComponent } from './editorial/cms-editorial.component';
import { CmsFaqComponent } from './faq/cms-faq.component';
import { CmsHeroBannerComponent } from './hero-banner/cms-hero-banner.component';
import { CmsHtmlComponent } from './html/cms-html.component';
import { CmsIframeComponent } from './iframe/cms-iframe.component';
import { CmsImageQuoteComponent } from './image-quote/cms-image-quote.component';
import { CmsImageComponent } from './image/cms-image.component';
import { CmsIndexedTextComponent } from './indexed-text/cms-indexed-text.component';
import { CmsInfoPagesListingComponent } from './info-pages-listing/cms-info-pages-listing.component';
import { CmsMosaicComponent } from './mosaic/cms-mosaic.component';
import { CmsNewsletterModalComponent } from './newsletter-modal/cms-newsletter-modal.component';
import { CmsProductCarouselComponent } from './product-carousel/cms-product-carousel.component';
import { ProductTrustpilotWidgetComponent } from './product-trustpilot-widget/product-trustpilot-widget.component';
import { CmsQuickLinksComponent } from './quick-links/cms-quick-links.component';
import { SamplesComponent } from './samples/samples.component';
import { CmsSectionComponent } from './section/cms-section.component';
import { CmsSeoContentComponent } from './seo-content/cms-seo-content.component';
import { CmsServiceMessagesComponent } from './service-messages/cms-service-messages.component';
import { CmsTableComponent } from './table/cms-table.component';
import { CmsTextComponent } from './text/cms-text.component';
import { CmsTrustpilotWidgetComponent } from './trustpilot-widget/cms-trustpilot-widget.component';
import { CmsUGCComponent } from './ugc/cms-ugc.component';
import { UGCModalComponent } from './ugc/tray/ugc-modal.component';
import { CmsVideoComponent } from './video/cms-video.component';

const COMPONENTS = [
    SamplesComponent,
    TextBoxComponent,
    CmsHeroBannerComponent,
    CmsCategoryRoutingComponent,
    CmsSectionComponent,
    CmsMosaicComponent,
    CmsFaqComponent,
    CmsAcoustics101Component,
    CmsInfoPagesListingComponent,
    CmsDiscoveryQuizComponent,
    CmsAnalysisCalculatorComponent,
    CmsTrustpilotWidgetComponent,
    CmsCaseStudiesComponent,
    CmsServiceMessagesComponent,
    CmsImageComponent,
    CmsVideoComponent,
    CmsUGCComponent,
    CmsQuickLinksComponent,
    CmsNewsletterModalComponent,
    CmsImageQuoteComponent,
    CmsEditorialComponent,
    CmsProductCarouselComponent,
    ProductTrustpilotWidgetComponent,
    CmsTableComponent,
    CmsAccordionComponent,
    CmsButtonComponent,
    CmsCustomFormComponent,
    CmsHtmlComponent,
    CmsIndexedTextComponent,
    CmsTextComponent,
    CmsSeoContentComponent,
    CmsIframeComponent,
    UGCModalComponent,
    PageHeaderMeganavContentItemComponent,
    CmsBlogComponentImageAndCopyComponent,
    CmsBlogComponentImagesComponent,
    CmsBlogComponentMoreStoriesComponent
];

export const provideCmsComponents = () => {
    return makeEnvironmentProviders([provideEnvironmentInitializer(() => surviveTreeShaking(COMPONENTS))]);
};
